(function ($) {
const MAPY_API_KEY = '9tnpjKOFHLsCt4m0LJGhXKyjumkH6nPAsMUEBYExyZI';

  /* ===============================
     ADMIN – ZÓNY + CENY
  =============================== */


  function getPriceForZone(zoneName) {
    const z = deliveryZonesConfig.find(z => z.name === zoneName);
    return z ? z.price : null;
  }

  const STORAGE_KEY = 'deliveryAddress_' + window.location.hostname;

  /* ===============================
     PROMĚNNÉ
  =============================== */
  let mapInitialized = false;
  let map = null;
  let zonesGeojson = null;
  let zonesLayer = null;
  let marker = null;
  let addressTimer = null;

  let lastSelectedAddress = null;
  let lastZone = null;
  let lastPrice = null;

  /* ===============================
     FORMAT ADRESY
  =============================== */
function formatAddress(item) {
  const street = item.name || '';
  const city = getMunicipality(item);
  const zip = (item.zip || '').replace(/\s+/g, '');

  let result = street;
  if (city) result += ', ' + city;
  if (zip) result += ' ' + zip;

  return result.trim();
}




  /* ===============================
     POINT IN POLYGON
  =============================== */
  function pointInPolygon(point, polygon) {
    const x = point[0];
    const y = point[1];
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0], yi = polygon[i][1];
      const xj = polygon[j][0], yj = polygon[j][1];
      const intersect =
        ((yi > y) !== (yj > y)) &&
        (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  function getZoneForPoint(point) {
    if (!zonesGeojson) return null;

    for (const feature of zonesGeojson.features) {
      const geom = feature.geometry;

      if (geom.type === 'Polygon') {
        if (pointInPolygon(point, geom.coordinates[0])) return feature.properties;
      }
      if (geom.type === 'MultiPolygon') {
        for (const poly of geom.coordinates) {
          if (pointInPolygon(point, poly[0])) return feature.properties;
        }
      }
    }
    return null;
  }

  /* ===============================
     MAPA
  =============================== */
  function initDeliveryMap() {
    if (mapInitialized) return;
    mapInitialized = true;

    map = L.map('customDeliveryMap', {
      scrollWheelZoom: false
    }).setView([49.8, 15.5], 7);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 19
    }).addTo(map);

    fetch('/user/documents/spomysl.geojson?v=' + new Date().getMinutes())
      .then(r => r.json())
      .then(data => {
        zonesGeojson = data;

        zonesLayer = L.geoJSON(data, {
          style: {
            color: '#81b644',
            weight: 1,
            fillOpacity: 0.2
          }
        }).addTo(map);

        map.fitBounds(zonesLayer.getBounds());
        setTimeout(() => map.invalidateSize(), 50);
      });
  }

  /* ===============================
     ADRESY – NOMINATIM
  =============================== */
 let addressAbortController = null;

function searchAddress(query) {
  return fetch(
    'https://api.mapy.cz/v1/suggest?' +
      new URLSearchParams({
        query: query,
        type: 'regional.address',
        limit: 6,
        lang: 'cs',
        apikey: MAPY_API_KEY
      })
  )
    .then(r => r.json())
    .then(data => data.items || []);
}

  /* ===============================
     COLORBOX
  =============================== */
  $('html').on('click', '.deliveryLink, i.chooseDeliveryMap', function (e) {
    e.preventDefault();

    $.colorbox({
      html: `
        <div class="customDeliveryWrapper">
          <h3>Kam vám objednávku doručíme?</h3>

          <div class="deliveryInputWrap">
            <label>Zadejte Vaši adresu:</label>

            <div class="inputWrap">
              <input type="text"
                     id="deliveryAddressInput"
                     placeholder="např. Spomyšl 163, Spomyšl 27705">
              <span id="saveDeliveryAddress" class="btn btn-primary disabled">
                Uložit adresu doručení
              </span>
            </div>

            <ul id="deliverySuggestions" style="display:none"></ul>
            <div id="deliveryResult"></div>
          </div>

         
          <div id="customDeliveryMap" style="height:337px;"></div>
        </div>
      `,
      width: 700,
      maxWidth: '95%',
      height: 590,
      maxHeight: '95%',
      className: 'mapaApi',

     onComplete: function () {
        initDeliveryMap();

        // počkáme, až se mapa fakt vykreslí
        setTimeout(() => {
          restoreDeliveryFromStorage(map);
        }, 300);
      },
      onCleanup: function () {
        mapInitialized = false;
        map = zonesGeojson = zonesLayer = marker = null;
        lastSelectedAddress = lastZone = lastPrice = null;
      }
    });
  });

  /* ===============================
     INPUT + DEBOUNCE
  =============================== */


$(document).on('input', '#deliveryAddressInput', function () {
  const val = $(this).val().trim();

  clearTimeout(addressTimer);
  $('#saveDeliveryAddress').removeClass('disabled');

  if (val.length < 3) {
    $('#deliverySuggestions').hide();
    return;
  }

  addressTimer = setTimeout(() => {
    searchAddress(val).then(results => {
      const $list = $('#deliverySuggestions').empty().show();

      const seen = new Set();

results.forEach(item => {
  const label = formatAddress(item);
  if (!label) return;
  $('<li>')
    .text(label)
    .appendTo($list)
    .on('click', function () {
      $list.hide();
      $('#deliveryAddressInput').val(label);

      const point = [
        item.position.lon,
        item.position.lat
      ];

      const zone = getZoneForPoint(point);

      lastSelectedAddress = {
        label: label,
        //street: item.regionalStructure || '',
        street: getRegionalPart(item, 'regional.street'),
        addressNumber: getRegionalPart(item, 'regional.address'),
        city: getMunicipality(item),
        zip: (item.zip || '').replace(/\s+/g, ''),
        lat: item.position.lat,
        lng: item.position.lon
      };

      if (marker) map.removeLayer(marker);
      marker = L.marker([item.position.lat, item.position.lon]).addTo(map);
      map.setView([item.position.lat, item.position.lon], 13);

      if (zone) {
        lastZone = zone.name;
        lastPrice = getPriceForZone(zone.name);
        $('.deliveryInputWrap').removeClass('notDelivery').addClass('yesDelivery');
        $('#deliveryResult')
          .removeClass('deliveryError')
          .addClass('deliveryOk')
          .text(
            'Skvělé! Na tuto adresu doručujeme. Cena dopravy je ' +
            lastPrice + ' Kč.'
          );

        $('#saveDeliveryAddress').removeClass('disabled');
      } else {
        lastZone = lastPrice = null;
        $('#saveDeliveryAddress').addClass('disabled');
        $('.deliveryInputWrap').removeClass('yesDelivery').addClass('notDelivery');
        $('#deliveryResult')
          .removeClass('deliveryOk')
          .addClass('deliveryError')
          .text(
            'Na zadanou adresu bohužel nedoručujeme. Zkontrolujte prosím zadané údaje.'
          );
      }
    });
});


      if (!$list.children().length) {
        $list.hide();
      }
    });
  }, 120); // ⚡ rychlejší odezva
});

  /* ===============================
     ULOŽENÍ DO sessionStorage
  =============================== */
$('html').on('click', '#saveDeliveryAddress', function () {

  const stored = sessionStorage.getItem(STORAGE_KEY);
  let fallback = null;

  if (stored) {
    try {
      fallback = JSON.parse(stored);
    } catch (e) {}
  }

  const dataToSave = {
    ...(fallback || {}),
    ...(lastSelectedAddress || {}),
    zone: lastZone ?? fallback?.zone ?? null,
    price: lastPrice ?? fallback?.price ?? null
  };

  if (!dataToSave.zone || !dataToSave.price) {
    console.warn('Ukládání zrušeno – neplatná data');
    return;
  }

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(dataToSave));
  if ($('.id--16').length) {
    refreshDeliveryUI();
}
  $.colorbox.close();

});

function getSuggestionKey(item) {
  const a = item.address || {};
  const street = [a.road, a.house_number].filter(Boolean).join(' ').toLowerCase();
  const city =
    (a.town || a.city || a.village || '').toLowerCase();
  const zip = (a.postcode || '').replace(/\s+/g, '');

  return `${street}|${city}|${zip}`;
}
})(jQuery);


function getRegionalPart(item, type) {
    if (!Array.isArray(item.regionalStructure)) {
        return '';
    }

    const found = item.regionalStructure.find(part => part.type === type);
    return found ? found.name : '';
}

function getMunicipality(item) {
  if (!item.regionalStructure) return '';

  const municipality = item.regionalStructure.find(
    r => r.type === 'regional.municipality'
  );

  return municipality ? municipality.name : '';
}

function getNextStepUrl() {
  const $btn = $('#continue-order-button');
  return $btn.attr('href') || '/objednavka/krok-1/';
}

function getNextStepUrlFromLink($link) {
  return $link.attr('href') || '/objednavka/krok-1/';
}


function openDeliveryPopupAndRedirect() {
  const STORAGE_KEY = 'deliveryAddress_' + window.location.hostname;
  const nextStepUrl = getNextStepUrl();
  $('.deliveryLink').first().trigger('click');
  const checkTimer = setInterval(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) {
      clearInterval(checkTimer);
      window.location.href = nextStepUrl;
    }
  }, 300);
}

function cartHasSpecialDeliveryItem() {
  let found = false;
  $('.cart-table tbody tr').each(function () {
    const availabilityText = $(this)
      .find('.availability-label')
      .text()
      .trim();
    if (stavyNaZony.some(function(state) {
        return availabilityText.includes(state);
      })) {
      found = true;
      return false; // break .each()
    }
  });
  return found;
}





if($('.id--9').length){
   document.addEventListener('ShoptetDOMContentLoaded', function () { 
      saveCartAvailabilityToStorage();
      var STORAGE_KEY = 'deliveryAddress_' + window.location.hostname;
    $('ol.cart-header').on('click', 'li.step-2 a[href]', function (e) {
        const $link = $(this);
        const hasSpecialItem = cartHasSpecialDeliveryItem();
        const hasAddress = !!sessionStorage.getItem(STORAGE_KEY);
        saveCartAvailabilityToStorage();
        if (hasSpecialItem && !hasAddress) {
          e.preventDefault();
          const nextStepUrl = getNextStepUrlFromLink($link);
          openDeliveryPopupAndRedirect(nextStepUrl);
          return false;
        }
      }
    );


    
      const $continueBtn = $('#continue-order-button');
      if (!$continueBtn.length) return;
      $continueBtn.on('click', function (e) {
        const hasSpecialItem = cartHasSpecialDeliveryItem();
        const hasAddress = !!sessionStorage.getItem(STORAGE_KEY);
        saveCartAvailabilityToStorage();
        if (hasSpecialItem && !hasAddress) {
          e.preventDefault();
          openDeliveryPopupAndRedirect();
          return false;
        }
        else{

        }
      });
   });

   $(document).ready(function () {
      const STORAGE_KEY = 'deliveryAddress_' + window.location.hostname;
      const $continueBtn = $('#continue-order-button');
      if (!$continueBtn.length) return;
      $continueBtn.on('click', function (e) {
        const hasSpecialItem = cartHasSpecialDeliveryItem();
        const hasAddress = !!sessionStorage.getItem(STORAGE_KEY);
        saveCartAvailabilityToStorage();
        if (hasSpecialItem && !hasAddress) {
          e.preventDefault();
          openDeliveryPopupAndRedirect();
          return false;
        }
        else{

        }
      });
  });

  $(document).ready(function () {
  const STORAGE_KEY = 'deliveryAddress_' + window.location.hostname;
    $('ol.cart-header').on('click', 'li.step-2 a[href]', function (e) {
        const $link = $(this);
        const hasSpecialItem = cartHasSpecialDeliveryItem();
        const hasAddress = !!sessionStorage.getItem(STORAGE_KEY);
        saveCartAvailabilityToStorage();
        if (hasSpecialItem && !hasAddress) {
          e.preventDefault();
          const nextStepUrl = getNextStepUrlFromLink($link);
          openDeliveryPopupAndRedirect(nextStepUrl);
          return false;
        }
      }
    );
  });
}



if ($('.id--16').length) {
    initShippingStep();
}

function initShippingStep() {
  //  handleShippingByAvailability();

    const STORAGE_KEY = 'deliveryAddress_' + window.location.hostname;
    const stored = sessionStorage.getItem(STORAGE_KEY);

    if (!stored) {
        return;
    }

    let data;

    try {
        data = JSON.parse(stored);
    } catch (e) {
        return;
    }

    if (!data || !data.zone) {
        return;
    }

    const allowedZone = data.zone.trim();

    $('#order-shipping-methods .radio-wrapper').each(function () {
        const $method = $(this);
        const name = $method.find('.shipping-billing-name').text().trim();

        if (name.startsWith('Přeprava naším autem')) {
            if (name !== allowedZone) {
                $method.hide();
                $method.find('input[type="radio"]').prop('disabled', true);
            } else {
                $method.find('.payment-info').append(`
                    <span class="deliveryPoint"><span>${data.label}</span></span>
                    <span class="sublabel">
                        <i class="chooseDeliveryMap">${translation('zmenaAdresy')}</i>
                    </span>
                `);
            }
        }
    });
}

if($('.id--17').length){
  $(function () {
    const hostname = window.location.hostname;
    const CART_STORAGE_KEY = 'cartAvailability_' + hostname;
    const cartRaw = sessionStorage.getItem(CART_STORAGE_KEY);
   if (cartRaw) {
        try {
            const cartData = JSON.parse(cartRaw);

            if (Array.isArray(cartData.items)) {

            const hasSpecialAvailability = cartData.items.some(item =>
                stavyNaZony.some(state =>
                    item.availability && item.availability.includes(state)
                )
            );

            if (!hasSpecialAvailability) {
                console.log('zrušeno, nemám dostupnost zónovou');
                return;
            }
        }

        } catch (e) {
            console.warn('Neplatný JSON v cartAvailability storage');
        }
    }

    /* === 2️⃣ vyplnění adresy === */
    const ADDRESS_STORAGE_KEY = 'deliveryAddress_' + hostname;
    const storedData = sessionStorage.getItem(ADDRESS_STORAGE_KEY);

    if (!storedData) {
        return;
    }

    let data;

    try {
        data = JSON.parse(storedData);
    } catch (e) {
        console.warn('Neplatný JSON v deliveryAddress storage');
        return;
    }
    if (!data.street && data.city) {
          data.street = data.city;
      }

    const fieldMap = {
        street: '#billStreet',
        city: '#billCity',
        zip: '#billZip',
        addressNumber: '#billHouseNumber'
    };

    $.each(fieldMap, function (key, selector) {
        if (data[key] !== undefined && $(selector).length) {
            $(selector)
                .val(data[key])
                .prop('readonly', true)
                .trigger('change')
                .trigger('input');
        }
    });

});

}


function restoreDeliveryFromStorage(map) {
  const STORAGE_KEY = 'deliveryAddress_' + window.location.hostname;
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (!stored) return;

  let data;
  try {
    data = JSON.parse(stored);
  } catch (e) {
    return;
  }

  // vyplnit input
  $('#deliveryAddressInput').val(data.label);

  // výsledek
  $('.deliveryInputWrap')
    .removeClass('notDelivery')
    .addClass('yesDelivery');

  $('#deliveryResult')
    .removeClass('deliveryError')
    .addClass('deliveryOk')
    .text(
      'Skvělé! Na tuto adresu doručujeme. Cena dopravy je ' +
      data.price + ' Kč.'
    );

  // enable button
  $('#saveDeliveryAddress').removeClass('disabled');

  // uložit do runtime proměnných
  lastSelectedAddress = data;
  lastZone = data.zone;
  lastPrice = data.price;

  // marker + mapa
  if (map && data.lat && data.lng) {
    marker = L.marker([data.lat, data.lng]).addTo(map);
    map.setView([data.lat, data.lng], 13);
  }
}


function collectCartAvailability() {
    const items = [];

    $('.cart-table tbody tr.removeable').each(function () {
        const $row = $(this);
        const code = $row.attr('data-micro-sku');
        const name = $row.find('.p-name .main-link').text().trim();

        const availabilityText = $row
            .find('.availability-label')
            .first()
            .text()
            .trim();

        

        items.push({
            code: code,
            name: name,
            availability: availabilityText,
        });
    });

    return items;
}

function saveCartAvailabilityToStorage() {
    const STORAGE_KEY = 'cartAvailability_' + window.location.hostname;

    const data = {
        items: collectCartAvailability(),
        savedAt: Date.now()
    };

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

/*
function hasPreorderItem(items) {
    return items.some(item =>
        typeof item.availability === 'string' &&
        item.availability.toLowerCase().includes(predobjednavkaLabel)
    );
}
*/

/*
function handleShippingByAvailability() {
  $(idPredobjednavka).find('.payment-info').append('<i>'+predobjednavka+'</i>')
    const STORAGE_KEY = 'cartAvailability_' + window.location.hostname;
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
        return;
    }
    let data;
    try {
        data = JSON.parse(raw);
    } catch (e) {
        return;
    }
    if (!data.items || !Array.isArray(data.items)) {
        return;
    }
    if (hasPreorderItem(data.items) && $(idPredobjednavka).length) {
      
        $('#order-shipping-methods').prepend('<div class="siteMsgCustomPredob"><p>'+predobjednavkaText+'</p></div>')
        return;
    }
    $(idPredobjednavka).hide();
}
*/
function refreshDeliveryUI() {

    const STORAGE_KEY =
        'deliveryAddress_' + window.location.hostname;

    const stored =
        sessionStorage.getItem(STORAGE_KEY);

    if (!stored) return;


    let data;

    try {
        data = JSON.parse(stored);
    } catch (e) {
        return;
    }


    if (!data.zone) return;


    const allowedZone =
        String(data.zone).trim();


    $('#order-shipping-methods .radio-wrapper')
        .each(function () {

            const $method = $(this);

            const name =
                $method
                    .find('.shipping-billing-name')
                    .text()
                    .trim();


            /*
             * OSTATNÍCH DOPRAV SE VŮBEC NEDOTÝKAT.
             */
            if (
                !name.startsWith(
                    'Přeprava naším autem'
                )
            ) {
                return;
            }


            /*
             * Naše vlastní vložené elementy
             */
            $method
                .find('.deliveryPoint, .sublabel')
                .remove();


            if (name !== allowedZone) {

                // jiná zóna
                $method.hide();

                $method
                    .find('input[type="radio"]')
                    .prop('disabled', true);

            } else {

                // správná zóna
                $method.show();

                $method
                    .find('input[type="radio"]')
                    .prop('disabled', false);


                $method
                    .find('.payment-info')
                    .append(`
                        <span class="deliveryPoint">
                            <span>${data.label}</span>
                        </span>

                        <span class="sublabel">
                            <i class="chooseDeliveryMap">
                                ${translation('zmenaAdresy')}
                            </i>
                        </span>
                    `);
            }
        });
}


/*
 * Zpřístupnění pro _predobjednavka.js
 */
window.refreshDeliveryUI = refreshDeliveryUI;
